import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from './Navbar';
import Hero from './Hero';
import DistanceEducation from './DistanceEducation';
// import SkillCertification from './SkillCertification';
import Aluminisuccessstories from './Alumnisuccessstories';
import Collaborations from './Collaborations';
import Footer from './Footer';
import GlobeReach from './GlobeReach';

function HomeIndex() {
  
  // 1. SCROLL TO TOP ON MOUNT
  // This ensures that whenever a user lands on this page, it forces the browser 
  // to start at the very top, fixing the common React Router scroll bug.
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Adds a nice smooth scroll effect
    });
  }, []);

  // 2. JSON-LD STRUCTURED DATA
  // This tells Google exactly who you are, making you eligible for Rich Snippets 
  // (like showing your contact info and address directly in Google search results).
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "AnaBel Institute",
    "url": "https://www.yourdomain.com", // Replace with your actual live URL
    "logo": "https://www.yourdomain.com/logo1.png", // Replace with actual logo URL
    "description": "Empowering youth with quality teacher education since 2007. Government approved and nationally recognized.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "1475, Park Rd, Opp Samskrutha Bhavan, Rangoli Halla",
      "addressLocality": "Hassan",
      "addressRegion": "Karnataka",
      "postalCode": "573201",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-99644-51828",
      "contactType": "admissions",
      "email": "anabel@gmail.com"
    }
  };

  return (
    // Changed <div> to <main> for better HTML semantic SEO structure
    <main style={{ fontFamily: "'Poppins', sans-serif" }}>
      
      {/* 3. SEO METADATA INJECTION */}
      <Helmet>
        {/* Core Search Engine Tags */}
        <title>AnaBel Institute | Quality Teacher Education & Training</title>
        <meta name="description" content="Discover premier teacher training, distance education, and Montessori programs at AnaBel Institute. Empowering youth since 2007 in Hassan, Karnataka." />
        
        {/* Social Media (Open Graph) Tags for Facebook/WhatsApp sharing */}
        <meta property="og:title" content="AnaBel Institute | Quality Teacher Education" />
        <meta property="og:description" content="Join our alumni success stories. We offer government-approved teacher training and distance education programs." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.yourdomain.com" />
        
        {/* Injecting the JSON-LD Script */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Page Content */}
      <Navbar />
      <Hero />

      <Aluminisuccessstories />
      <GlobeReach />
      <DistanceEducation />
      <Collaborations />
      {/* <SkillCertification /> */}
      <Footer />
      
    </main>
  );
}

export default HomeIndex;